import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Row from "../common/layout/row";
import "./extracoes.css";

import { Sistema_ID } from "../modules/constants";

//Actions
import { selectConcursoScreen } from "../reducers/concurso/concursoActions";
import {
  recuperaExtracao,
  cleanExtracao,
} from "../reducers/relatorios/extracoesActions";

import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";

import MomentLocaleUtils from "react-day-picker/moment";
import { formatDate, parseDate } from "react-day-picker/moment";
import "moment/locale/pt-br";
import { forceInt } from "../utils/forceInt";

class extracoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: new Date(),
      isEmpty: true,
      isDisabled: false,
      isLoading: false,
    };

    this.goHome = this.goHome.bind(this);
    this.loadExtracao = this.loadExtracao.bind(this);
    this.getListOk = this.getListOk.bind(this);
    this.renderExtracao = this.renderExtracao.bind(this);
    this.renderExtracaoRows = this.renderExtracaoRows.bind(this);
    this.renderDateRange = this.renderDateRange.bind(this);
    this.handleCurrentDayChange = this.handleCurrentDayChange.bind(this);
  }

  componentWillMount() {
    this.props.cleanExtracao([]);
  }

  componentDidUpdate() {}

  getListOk() {
    this.setState({
      isLoading: false,
    });
  }

  loadExtracao() {
    this.setState({
      isLoading: true,
    });

    var transaction = {};
    transaction.Sistema_ID = Sistema_ID;
    transaction.Cliente_ID = this.props.objUser.Cliente_ID;
    transaction.Site_ID = forceInt(this.props.objUser.Site_ID);
    transaction.CID = this.props.objUser.CID;
    transaction.chrSerial = this.props.objUser.ChrSerial;
    transaction.Session_ID = this.props.objUser.Session_ID;
    transaction.SessionIDLE = this.props.objUser.SessionIDLE;
    transaction.LoginLE = this.props.objUser.LoginLE;
    transaction.sdtData = this.state.currentDate;

    this.props.recuperaExtracao(transaction, this.getListOk);
  }

  goHome() {
    this.props.selectConcursoScreen(0);
  }

  handleCurrentDayChange(selectedDay, modifiers, dayPickerInput) {
    const input = dayPickerInput.getInput();

    this.setState({
      currentDate: selectedDay,
    });
  }

  renderDateRange() {
    try {
      return (
        <div>
          <DayPickerInput
            value={this.state.currentDate}
            onDayChange={this.handleCurrentDayChange}
            format="L"
            formatDate={formatDate}
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays: this.state.currentDate,
              localeUtils: MomentLocaleUtils,
              locale: "pt-br",
            }}
          />
          <button type="button" className="btn" onClick={this.loadExtracao}>
            Ok
          </button>
        </div>
      );
    } catch (error) {
      alert(error);
    }
  }

  renderExtracaoRows(arrExtracao) {
    if (arrExtracao != undefined) {
      return arrExtracao.map((res) => (
        <tr role="row" className="odd">
          <td>{res.vchDescricao}</td>
          <td>{res.chrHorario}</td>
          <td>{res.chrHorarioBloqueio}</td>
        </tr>
      ));
    } else return null;
  }

  renderExtracao() {
    if (
      this.props.extracaoJBWeb != undefined &&
      this.props.extracaoJBWeb.arrExtracoes != undefined
    ) {
      return (
        <div className="row">
          <div className="col-sm-12">
            <h4>Extrações</h4>
            <table
              id="example2"
              className="table table-bordered table-hover dataTable"
              role="grid"
              aria-describedby="example2_info"
            >
              <thead>
                <tr role="row">
                  <th tabindex="0">Descrição</th>
                  <th tabindex="0">Horário</th>
                  <th tabindex="0">Horário Bloqueio</th>
                </tr>
              </thead>
              <tbody>
                {this.renderExtracaoRows(this.props.extracaoJBWeb.arrExtracoes)}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  render() {
    const detailsColumnStyle = {
      width: "10px",
    };

    let loader = !this.state.isLoading ? null : (
      <div className="loader" style={{ marginTop: "0" }}></div>
    );

    return (
      <div className={"suas-apostas-container " + this.state.startDate}>
        <section className="col-xs-12">
          <div className="box">
            <div className="box-header header">
              <div className="col-xs-12">
                <a className="btn btn-danger pull-right" onClick={this.goHome}>
                  Voltar
                </a>
              </div>
              <div className="col-xs-12">
                <span className="box-title">Data da Extração</span>
                {this.renderDateRange()}
              </div>
            </div>
            <div className="box-body">
              {this.renderExtracao()}
              {loader}
            </div>
            <div className="box-footer">
              <Row></Row>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  objUser: state.usuario.objUser,
  extracaoJBWeb: state.extracoes.extracaoJBWeb,
  concursoType: state.concurso.concursoType,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectConcursoScreen,
      recuperaExtracao,
      cleanExtracao,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(extracoes);



// WEBPACK FOOTER //
// ./src/relatorios/extracoes.jsx